module.exports = __webpack_public_path__ + "img/user.77a09994.png";